/**
 * Mock content cards data for local development when Braze is not available.
 * Enable via site setting: MOCK_BRAZE_CONTENT_CARDS
 * 
 * This mimics the Dream Snacks campaign card from Braze with a real ID so clicks track properly.
 * Falls back to plain objects if Braze SDK is not available (e.g., in tests).
 */

// Try to import Braze Card classes - may not be available in test environment
let ClassicCard;
try {
  // eslint-disable-next-line global-require
  const braze = require('@braze/web-sdk');
  ClassicCard = braze.ClassicCard;
} catch (e) {
  // Braze SDK not available, will use plain objects
}

const isBrazeAvailable = typeof ClassicCard === 'function';

// Real Braze card ID for Dream Snacks campaign
const DREAM_SNACKS_CARD_ID = 'Njk3OGNhZjk2MDViNGEwMDYzZDM4N2IwXyRfY2M9YWVmNGIyYTQtZDU3My04N2Q3LTFlYzYtOTc1NDdjYzUxZDk2Jm12PTY5NzhjYWY5NjA1YjRhMDA2M2QzODdhNSZwaT1jbXA=';

/**
 * Create a HeroIntroPromo (ClassicCard) instance mimicking Dream Snacks campaign
 */
const createHeroIntroPromoCard = () => {
  // Use Braze Card instance if available
  if (isBrazeAvailable) {
    return new ClassicCard(
      DREAM_SNACKS_CARD_ID,            // id - real Braze card ID
      false,                           // viewed
      'MOCK: Dream Snacks',           // title with MOCK: prefix
      null,                            // imageUrl (uses extras.images)
      'Our new Valentine\'s Day flavors are warm, melty, and straight out of your sweetest dreams.', // description
      new Date(),                     // updated
      new Date(Date.now() + 86400000 * 30), // expiresAt (30 days from now)
      '#for-you',                     // url
      'Open',                         // linkText
      1.0,                            // aspectRatio
      {                               // extras
        template: 'HeroIntroPromo',
        titleBold: '',
        titleColor: '#FFFFFF',
        titleItalic: '0',
        preheaderText: 'Limited time!',
        mobileImageUrl: 'https://braze-images.com/appboy/communication/assets/image_assets/images/68bf11e40326cd0065ba8d99/original.jpg?1757352420',
        desktopImageUrl: 'https://braze-images.com/appboy/communication/assets/image_assets/images/68bf12f055a1da0066a39150/original.jpg?1757352688',
        actionButtonFill: '#E01766',
        actionButtonText: 'Order Now',
        actionButtonTextColor: '#F6F3F7',
        includePages: 'https://insomniacookies.com/',
      },
      false, // pinned
      false, // dismissible
      false, // clicked
      null,  // language
      null   // altImageText
    );
  }
  
  // Fallback to plain object if Braze SDK is not available
  return {
    id: DREAM_SNACKS_CARD_ID,
    viewed: false,
    title: 'MOCK: Dream Snacks',
    imageUrl: null,
    description: 'Our new Valentine\'s Day flavors are warm, melty, and straight out of your sweetest dreams.',
    updated: new Date(),
    expiresAt: new Date(Date.now() + 86400000 * 30),
    url: '#for-you',
    linkText: 'Open',
    aspectRatio: 1.0,
    extras: {
      template: 'HeroIntroPromo',
      titleBold: '',
      titleColor: '#FFFFFF',
      titleItalic: '0',
      preheaderText: 'Limited time!',
      mobileImageUrl: 'https://braze-images.com/appboy/communication/assets/image_assets/images/68bf11e40326cd0065ba8d99/original.jpg?1757352420',
      desktopImageUrl: 'https://braze-images.com/appboy/communication/assets/image_assets/images/68bf12f055a1da0066a39150/original.jpg?1757352688',
      actionButtonFill: '#E01766',
      actionButtonText: 'Order Now',
      actionButtonTextColor: '#F6F3F7',
      includePages: 'https://insomniacookies.com/',
    },
    pinned: false,
    dismissible: false,
    clicked: false,
    language: null,
    altImageText: null,
    rawCardData: {} // Add this so tracking code recognizes it as a Braze Card
  };
};

/**
 * Get mock content cards - returns only Dream Snacks card for tracking
 */
export const getMockContentCards = () => {
  return {
    cards: [
      createHeroIntroPromoCard(),
    ]
  };
};

// Keep these exports for backwards compatibility
export const mockHeroIntroPromoCard = createHeroIntroPromoCard();
export const mockContentCardsResponse = getMockContentCards();
